<template>
  <TabContentLayout id="general-tab">
    <ValidationObserver ref="mainObserver">
      <b-row v-if="readOnly">
        <b-col>
          <div class="d-flex justify-content-between align-items-center">
            <SubHeaderSection
              title="Responsables"
              description="Quien crea, coordina y ejecuta la llamada de servicio"
              bg-icon="#1d58b7"
              bg-color="#f0f0f0"
              class="pl-1"
            >
              <font-awesome-icon :icon="['fas', 'users']" size="lg" fixed-width />
            </SubHeaderSection>
            <!-- <div>
              <b-button
                variant="outline-dark"
                size="sm"
                class="mr-3 float-right p-0"
                style="width: fit-content;"
                @click="collapseStates.responsiblePeople = !collapseStates.responsiblePeople"
              >
                <font-awesome-icon v-if="collapseStates.responsiblePeople" :icon="['fas', 'caret-down']" class="text-dark" size="xl" fixed-width/>
                <font-awesome-icon v-else :icon="['fas', 'caret-right']" class="text-dark" size="xl" fixed-width />
              </b-button>
            </div> -->
          </div>
        </b-col>
      </b-row>

      <b-collapse
        v-if="readOnly"
        id="accordion-1"
        accordion="my-collapse"
        v-model="collapseStates.responsiblePeople"
      >
        <b-row>
          <b-col cols="6">
            <div>
              <p class="group-label mb-0 border-0 fs-12 pb-0">Creación</p>
              <p class="mb-1 fs-15 ml-2" style="color: #111827;">
                <span v-if="serviceCall.created_by">
                  <font-awesome-icon :icon="['fas', 'user-circle']" fixed-width />
                  {{ serviceCall.created_by | concatName2 }}
                </span>
                <span v-else-if="serviceCall.coordinator_name">
                  <font-awesome-icon :icon="['fas', 'user-circle']" fixed-width />
                  {{ serviceCall.coordinator_name }}
                </span>
                <span v-else>-</span>
              </p>
            </div>
            <div>
              <p class="group-label mb-0 border-0 fs-12 pb-0">Coordinación</p>
              <p class="mb-1 fs-15 ml-2" style="color: #111827;">
                <span v-if="event.coordinator">
                  <font-awesome-icon :icon="['fas', 'user-circle']" fixed-width />
                  {{ event.coordinator | concatName2 }}
                </span>
                <span v-else>-</span>
              </p>
            </div>
          </b-col>
          <b-col cols="6">
            <div>
              <p class="group-label mb-0 border-0 fs-12 pb-0">Ejecución</p>
              <p class="mb-1 fs-15 ml-2" style="color: #111827;">
                <span v-if="event.technician_name">
                  <font-awesome-icon :icon="['fas', 'user-circle']" fixed-width />
                  {{ event.technician_name }}
                </span>
                <span v-else>-</span>
              </p>
            </div>
          </b-col>
        </b-row>

        <hr>
      </b-collapse>

      <b-row>
        <b-col>
          <div class="d-flex justify-content-between align-items-center">
            <SubHeaderSection
              title="Cliente"
              description="Información del (cliente, contacto y dirección)"
              bg-icon="#1d58b7"
              bg-color="#f0f0f0"
              class="pl-1"
            >
              <font-awesome-icon :icon="['fas', 'industry-alt']" size="lg" fixed-width />
            </SubHeaderSection>
            <!-- <div v-if="readOnly">
              <b-button
                variant="outline-dark"
                size="sm"
                class="mr-3 float-right p-0"
                style="width: fit-content;"
                @click="collapseStates.client = !collapseStates.client"
              >
                <font-awesome-icon v-if="collapseStates.client" :icon="['fas', 'caret-down']" class="text-dark" size="xl" fixed-width/>
                <font-awesome-icon v-else :icon="['fas', 'caret-right']" class="text-dark" size="xl" fixed-width />
              </b-button>
            </div> -->
          </div>
        </b-col>
      </b-row>

      <b-row class="px-2">
        <b-col lg="6">
          <template v-if="readOnly">
            <div class="group">
              <p class="group-label">Cliente</p>
              <ReadonlyField label="Nombre">
                <template v-if="serviceCall.client_id">
                  {{ serviceCall.client_code }} - {{ serviceCall.client_name }}
                </template>
                <template v-else>{{ serviceCall.client_name }}</template>
              </ReadonlyField>
            </div>
            <div class="group">
              <p class="group-label">Contacto</p>
              <ReadonlyField label="Solicitado por"     :value="serviceCall.solicited_by" />
              <ReadonlyField label="Teléfono"           :value="serviceCall.telephone" />
              <ReadonlyField label="Correo electrónico" :value="serviceCall.contact_email" />
            </div>
          </template>
          <template v-else>
            <div class="group">
              <p class="group-label">Cliente</p>
              <ClientForm
                :client-form="form.client"
                @client-selected="onClientSelected"
                @client-reset="onClientReset"
              />
            </div>
            <div class="group">
              <p class="group-label">Contacto</p>
              <ContactForm
                :contact-form="form.contact"
                :contacts="clientContacts"
                :client-id="form.client.client_id"
              />
            </div>
          </template>
        </b-col>
        <b-col lg="6">
          <template v-if="readOnly">
            <div class="group">
              <p class="group-label">Dirección</p>
              <ReadonlyField label="Tipo de asistencia" :value="serviceCall.assistance_type" />
              <ReadonlyField label="Coordenadas"        :value="serviceCall.geo_location" />
              <ReadonlyField
                v-if="serviceCall.client_address && serviceCall.client_address.province"
                label="Provincia"
                :value="provinceName"
              />
              <ReadonlyField
                v-if="serviceCall.client_address && serviceCall.client_address.canton"
                label="Cantón"
                :value="serviceCall.client_address.canton"
              />
              <ReadonlyField
                v-if="serviceCall.client_address && serviceCall.client_address.district"
                label="Distrito"
                :value="serviceCall.client_address.district"
              />
              <ReadonlyField
                label="Dirección exacta"
                :value="serviceCall.address"
              />
            </div>
          </template>
          <template v-else>
            <div class="group">
              <p class="group-label">Dirección</p>
              <AddressForm
                :address-form="form.address"
                :addresses="clientAddresses"
                :client-id="form.client.client_id"
              />
            </div>
          </template>
        </b-col>
      </b-row>

      <hr>

      <b-row class="mt-1">
        <b-col>
          <SubHeaderSection
            title="Servicio"
            description="Detalles del servicio solicitado"
            bg-icon="#1d58b7"
            bg-color="#f0f0f0"
            class="pl-1"
          >
            <font-awesome-icon :icon="['fas', 'wrench']" size="lg" fixed-width />
          </SubHeaderSection>
        </b-col>
      </b-row>

      <b-row class="px-2">
        <b-col>
          <template v-if="readOnly">
            <b-row>
              <b-col lg="6">
                <div class="group">
                  <ReadonlyField label="Fecha de compromiso" :value="serviceCall.due_on | formatDate" />
                  <ReadonlyField label="Categoría del servicio" :value="sapSeriesMap[serviceCall.sap_series]" />
                  <ReadonlyField label="Unidad de negocio" :value="callTypeMap[serviceCall.call_type]" />
                  <ReadonlyField label="¿Valorar garantía?" :value="serviceCall.warranty_evaluation_required ? 'Sí' : 'No'" />
                  <ReadonlyField label="Descripción del problema" :value="serviceCall.subject" />
                </div>
              </b-col>
              <b-col lg="6">
                <div class="group">
                  <ReadonlyField label="¿Es un problema recurrente?" :value="serviceCall.is_recurring ? 'Sí' : 'No'" />
                  <ReadonlyField label="Tipo de equipo" :value="serviceCall.system_type" />
                  <ReadonlyField label="Tipo de problema" :value="serviceCall.problem_type_name" />
                  <ReadonlyField label="Número de serie" :value="serviceCall.item_serial_no" />
                  <ReadonlyField label="Forma de pago" :value="serviceCall.payment_type" />
                  <ReadonlyField label="Comentarios internos" :value="serviceCall.comments" />
                </div>
              </b-col>
            </b-row>
          </template>
          <template v-else>
            <ServiceForm
              :service-form="form.service"
              :client-form="form.client"
            />
          </template>
        </b-col>
      </b-row>
    </ValidationObserver>
  </TabContentLayout>
</template>

<script>

import { ValidationObserver } from 'vee-validate'

import TabContentLayout from './TabContentLayout'
import SubHeaderSection from '../SubHeaderSection'
import ClientForm from './forms/ClientForm'
import ContactForm from './forms/ContactForm'
import AddressForm from './forms/AddressForm'
import ServiceForm from './forms/ServiceForm'
import { provinces } from '../../../../sharedOptions/provinces'
import {
  sapSeriesMap,
  callTypeMap
} from '../../../../sharedOptions/serviceCallModule'

const ReadonlyField = {
  name: 'ReadonlyField',
  functional: true,
  props: {
    label: { type: String,  required: true },
    value: { type: [String, Number, Boolean], default: undefined },
    empty: { type: String,  default: 'Pendiente' },
  },
  render(h, ctx) {
    const { label, value, empty } = ctx.props
    const hasSlot  = !!ctx.slots().default
    const hasValue = value !== undefined && value !== null && value !== ''

    const rightContent = hasSlot
      ? h('span', { class: 'ro-value' }, ctx.slots().default)
      : hasValue
        ? h('span', { class: 'ro-value' }, String(value))
        : h('span', { class: 'text-danger ro-value' }, empty)

    return h('div', { class: 'ro-field' }, [
      h('span', { class: 'ro-label' }, label),
      rightContent,
    ])
  }
}

export default {
  name: 'GeneralTab',
  components: {
    TabContentLayout, SubHeaderSection, ValidationObserver,
    ClientForm, ContactForm, AddressForm, ReadonlyField,
    ServiceForm
  },
  props: {
    serviceCall: { type: Object,  required: true },
    event: { type: Object,  required: true },
    readOnly:    { type: Boolean, required: true },
    form:        { type: Object,  required: true },
  },
  data() {
    return {
      clientContacts:  [],
      clientAddresses: [],
      sapSeriesMap: sapSeriesMap,
      callTypeMap: callTypeMap,
      provincesMap: provinces,
      collapseStates: {
        responsiblePeople: true,
        client: true,
        service: true
      }
    }
  },
  computed: {
    provinceName() {
      if (!this.serviceCall.client_address || !this.serviceCall.client_address.province) return ''
      const found = provinces.find(p => p.value === String(this.serviceCall.client_address.province))
      return found ? found.text : this.serviceCall.client_address.province
    }
  },
  watch: {
    'readOnly' (newVal, _oldVal) {
      if (newVal === true) return

      if (this.clientContacts.length == 0  && this.clientAddresses.length == 0) {
        this.fetchRelatedData(this.serviceCall.client_id)
      }
    }
  },
  methods: {
    onClientSelected (client) {
      this.fetchRelatedData(client.id)
    },
    onClientReset () {
      this.clientContacts  = []
      this.clientAddresses = []
    },
    fetchRelatedData (clientId) {
      if (!clientId) return
      this.$http.get(`/api/production/clients/${clientId}/fetch_related_data`)
        .then(({ data }) => {
          this.clientContacts  = data.client_contacts  || []
          this.clientAddresses = data.client_addresses || []
        })
        .catch(err => console.error(err))
    },
    async checkFormValidity () {
      if (this.readOnly) return false

      return await this.$refs.mainObserver.validate()
    }
  }
}
</script>

<style scoped>
.group { margin-bottom: 16px; }

.group-label {
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #163D7D;
  margin: 0 0 6px;
  padding-bottom: 4px;
  border-bottom: 1px solid #f3f4f6;
}

.ro-field {
  display: flex;
  flex-direction: column;
  padding: 6px 0;
  border-bottom: 1px solid #f9fafb;
  font-size: 13px;
}
.ro-field:last-child { border-bottom: none; }

.ro-label {
  font-size: 11px;
  font-weight: 500;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 2px;
}
.ro-value { color: #111827; font-size: 14px; }

@media (min-width: 992px) {
  .group-label { font-size: 15px; }
  .ro-field { flex-direction: row; align-items: baseline; gap: 8px; }
  .ro-label {
    min-width: 150px; flex-shrink: 0;
    font-size: 15px; font-weight: 400;
    text-transform: none; letter-spacing: normal;
    color: #6b7280; margin-bottom: 0;
  }
  .ro-value { font-size: 15px; }
}
</style>
